import styled from "styled-components";

interface props {
  isError?: boolean;
}

export const Container = styled.div<props>`
  display: flex;
  border-radius: 8px;
  background-color: #ffffff;
  flex-direction: column;
  width: 100%;
  outline: ${(props) => props?.isError && "1px solid red"};
`;
